export const ACCOUNT_TYPE_OPTIONS = [
  { label: 'Bank', value: 'Bank' },
  { label: 'Accounts receivable (A/R)', value: 'Accounts receivable (A/R)' },
  { label: 'Other current assets', value: 'Other current assets' },
  { label: 'Fixed assets', value: 'Fixed assets' },
  { label: 'Other assets', value: 'Other assets' },
  { label: 'Accounts payable (A/P)', value: 'Accounts payable (A/P)' },
  { label: 'Credit card', value: 'Credit card' },
  { label: 'Other current liabilities', value: 'Other current liabilities' },
  { label: 'Long-term liabilities', value: 'Long-term liabilities' },
  { label: 'Equity', value: 'Equity' },
  { label: 'Income', value: 'Income' },
  { label: 'Other income', value: 'Other income' },
  { label: 'Expenses', value: 'Expenses' },
  { label: 'Cost of goods sold', value: 'Cost of goods sold' },
  { label: 'Other expense', value: 'Other expense' },
];

export const DETAIL_TYPE_OPTIONS = [
  { label: 'Chequing', value: 'Chequing' },
  { label: 'Savings', value: 'Savings' },
  { label: 'Money market', value: 'Money market' },
  { label: 'Cash on hand', value: 'Cash on hand' },
  { label: 'Accounts Receivable (A/R)', value: 'Accounts Receivable (A/R)' },
  { label: 'Allowance for bad debts', value: 'Allowance for bad debts' },
  { label: 'Inventory', value: 'Inventory' },
  { label: 'Prepaid Expenses', value: 'Prepaid Expenses' },
  { label: 'Undeposited Funds', value: 'Undeposited Funds' },
  { label: 'Other current assets', value: 'Other current assets' },
  { label: 'Furniture and equipment', value: 'Furniture and equipment' },
  { label: 'Vehicles', value: 'Vehicles' },
  { label: 'Accumulated depreciation', value: 'Accumulated depreciation' },
  { label: 'Other assets', value: 'Other assets' },
  { label: 'Accounts Payable (A/P)', value: 'Accounts Payable (A/P)' },
  { label: 'Payroll liabilities', value: 'Payroll liabilities' },
  { label: 'Credit card', value: 'Credit card' },
  { label: 'Notes payable', value: 'Notes payable' },
  { label: "Owner's equity", value: "Owner's equity" },
  { label: 'Retained earnings', value: 'Retained earnings' },
  { label: 'Service/fee income', value: 'Service/fee income' },
  { label: 'Sales of product income', value: 'Sales of product income' },
  { label: 'Other miscellaneous income', value: 'Other miscellaneous income' },
  { label: 'Office/general administrative expenses', value: 'Office/general administrative expenses' },
  { label: 'Rent or lease of buildings', value: 'Rent or lease of buildings' },
  { label: 'Utilities', value: 'Utilities' },
  { label: 'Insurance', value: 'Insurance' },
  { label: 'Legal and professional fees', value: 'Legal and professional fees' },
  { label: 'Travel', value: 'Travel' },
  { label: 'Meals and entertainment', value: 'Meals and entertainment' },
  { label: 'Advertising/promotional', value: 'Advertising/promotional' },
  { label: 'Bank fees', value: 'Bank fees' },
  { label: 'Payroll expenses', value: 'Payroll expenses' },
];